import React, { useState } from "react";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";
import { MdPlayArrow } from "react-icons/md";
import { Modal, Button, H } from "@dossier/salvia-ui";
import ReactExample from "./ExampleApp";
// eslint-disable-next-line import/no-webpack-loader-syntax
import reactExampleRaw from "!!raw-loader!./ExampleApp.tsx";

export default function ReactExampleCode() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <h1>React example code:</h1>

      <p>
        This example code lets you log in and out of profile, and select
        employments. It demonstrates some different ways to use minibeak.
      </p>

      <Button
        elementSize="large"
        intent="primary"
        onClick={() => setModalOpen(true)}
      >
        <MdPlayArrow /> Preview
      </Button>

      <JsxSyntaxHighlighter>
        {reactExampleRaw.replace('"../../../lib/index"', '"@dossier/minibeak"')}
      </JsxSyntaxHighlighter>

      {modalOpen && (
        <Modal
          header={<H>Preview</H>}
          onCancel={() => setModalOpen(false)}
          width="40em"
        >
          <ReactExample />
        </Modal>
      )}
    </>
  );
}
